import styled from 'styled-components';
import { rgba } from '@helpers/style';

export const CreditBox = styled.span`
	background-color: ${(p) => rgba(p.theme.color.grayLight, 0.2)};
	border-radius: 99px;
	padding: 2px 10px;
  margin: 0 5px;
	span {
		font-size: 12px;
		display: inline-block;
		direction: rtl;
		padding: 0 2px;
    text-wrap: nowrap;
	}

	.icon {
		font-size: 16px;
		padding: 0 2px;
	}
`;
export const CreditContainer=styled.span`
  display: flex;
`